import { listdata, urlpostfix, jsonpostfix } from "@/http/global.js";
import { post, getJSON } from "@/http/http.js";

/**
 *
 * @description  字典列表接口
 *
 *
 * */
export function getDictList(dictType) {
  // console.log("data：", data);
  let data = {
    dictType
  };
  return post(`${urlpostfix}api/system/dictData/getDictList`, data);
}



// WEBPACK FOOTER //
// ./src/api/dict-data.js